export const NWD_VERSION = 'network-dashboard@v9.15.1';
